export default class BudResLinesRowData {
    constructor(value) {
        this.chargeType = value.chargeType[0] || "";
        this.brand = value.brand[0] || "";
        this.chargePeriod = value.chargePeriod[0] || "";
        this.docDate = value.docDate[0] || "";
        this.countryCode = value.countryCode[0] || "";
        this.stName = value.stName[0] || "";
        this.stNumber = value.stNumber[0] || "";
        this.custNo = value.custNo[0] || "";
        this.licCustNo = value.licCustNo[0] || "";
        this.pickUpText = value.pickUpText[0] || "";
        this.pickUpDate = value.pickUpDate[0] || "";
        this.rentName = value.rentName[0] || "";
        this.resNo = value.resNo[0] || "";
        this.resCTR = value.resCTR[0] || "";
        this.clInd = value.clind[0] || "";
        this.stationInd = value.stationInd[0] || "";
        this.rentDays = value.rentDays[0] || "";
        this.desc = value.desc[0] || "";
        this.source = value.source[0] || "";
        this.curr = value.curr[0] || "";
        this.unitPrice = value.unitPrice[0] || "";
        this.sourceCode = value.sourceCode[0] || "";
        this.chargeCode1 = value.chargeCode1[0] || "";
        this.chargeCode2 = value.chargeCode2[0] || "";
    }
}